import { RouteType } from "types/RouteType";
import MaterialInventoryStore from "./MaterialInventory.Store";

const MaterialInventoryRoute: RouteType = {
  name: "Material Inventory",
  path: "/inventory/materials",
  layout: "/app",
  group: "Inventory",
  requiresAuth: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "Material Inventory",
      enableRefreshButton: true,
      enableBackButton: true,
    },
    body: {
      component: () => import("./MaterialInventory.Body"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }) => {
    // Initialize store if not exists
    if (!rootStore.materialInventoryStore) {
      rootStore.materialInventoryStore = new MaterialInventoryStore(rootStore);
    }
    // Reset to clean state when entering
    const store = rootStore.materialInventoryStore as MaterialInventoryStore;
    store.reset();
    return true;
  },
};

export default MaterialInventoryRoute;
